import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import queryString from 'query-string'
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import FormLabel from "@material-ui/core/FormLabel";
import Checkbox from "@material-ui/core/Checkbox";
import PaymentButton from '../../custom_components/Payment'
// material ui icons
import MailOutline from "@material-ui/icons/MailOutline";
import Contacts from "@material-ui/icons/Contacts";
import Check from "@material-ui/icons/Check";
import Mic from "@material-ui/icons/Add";
import green from '@material-ui/core/colors/green';
// core components
import * as track from '../../data/track/track';
import GridContainer from "src/components/Grid/GridContainer.jsx";
import GridItem from "src/components/Grid/GridItem.jsx";
import CustomInput from "src/components/CustomInput/CustomInput.jsx";
import Button from "src/components/CustomButtons/Button.jsx";
import Card from "src/components/Card/Card.jsx";

import CardHeader from "src/components/Card/CardHeader.jsx";
import CardText from "src/components/Card/CardText.jsx";
import CardIcon from "src/components/Card/CardIcon.jsx";
import CardBody from "src/components/Card/CardBody.jsx";

import CardFooter from "src/components/Card/CardFooter.jsx";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Switch from "@material-ui/core/Switch";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import customSelectStyle from "src/assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import { cardTitle } from "src/assets/jss/material-dashboard-pro-react.jsx";
import ImageUpload from "src/components/CustomUpload/ImageUpload.jsx";
import * as model from '../../data/model';

import * as types from '../../types'
import { SSL_OP_NETSCAPE_CA_DN_BUG } from "constants";
import * as firebase from 'firebase/app';
import { createVerify } from "crypto";
import { string } from "prop-types";
import { type } from "os";
const styles = {
    cardTitle: {
        ...cardTitle,
        color: "#FFFFFF"
    },
    cardIconTitle: {
        ...cardTitle,
        marginTop: "15px",
        marginBottom: "0px"
    },
    ...customSelectStyle,
    select: {
        paddingTop: '10px'
    },
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    registerButton: {
        float: "right"
    }
};
let categories = model.PodCastCatgory.getCategories();


interface CreateTrackProps {
    classes: any;
    connect: types.IState;
}
interface CreateTrackState {
    step: CreateTrackStep;
    url?: string;
    text?: string;
    podcastId: any;
    createTrackRequest: model.CreateTrackRequest;
    errors: Array<types.ValidationError>;
    fieldCheck: any;
}
enum CreateTrackStep { url = 'url', processingUrl = 'processing', verify = 'verify', working = 'working', done = 'done' }
let helper = new types.ValidationHelper();
export class UrlOrTextRule implements types.IValidationRule {
    validate(form: any, field: string, value: any): types.ValidationRuleResult {
        if (!form['url'] && !form['text'])
            return types.ValidationRuleResult.error(null, 'Must provide a valid Url or Text');
        if (form['url'] && form['text'])
            return types.ValidationRuleResult.error(null, 'Must provide either a valid Url or Text.  Not both');

    }
}
export class UrlAndText implements types.IValidationRule {
    validate(form: any, field: string, value: any): types.ValidationRuleResult {

        if (value && form['text'])
            return types.ValidationRuleResult.error(field, 'Must provide either a valid Url or Text.  Not both.');

    }
}
export class TextAndUrl implements types.IValidationRule {
    validate(form: any, field: string, value: any): types.ValidationRuleResult {

        if (value && form['url'])
            return types.ValidationRuleResult.error(field, 'Must provide either a valid Url or Text.  Not both.');

    }
}
helper.fields = [
    {
        field: 'url',
        rules: [new types.UrlRule(), new UrlAndText()]
    },
    {
        field: 'text',
        rules: [new TextAndUrl()]
    }

];

helper.generalRules = [
    new UrlOrTextRule()
]
class CreateTrackView extends React.Component<CreateTrackProps, CreateTrackState> {
    constructor(props: CreateTrackProps) {
        super(props);
        this.state = {
            step: CreateTrackStep.url,
            url: undefined,
            createTrackRequest: new model.CreateTrackRequest(),
            podcastId: null,
            errors: new Array<types.ValidationError>(),
            fieldCheck: {}

        };

    }

    async processUrl(e) {
        try {

            let s = { ...this.state }
            s.step = CreateTrackStep.processingUrl;
            this.setState(s);
            var createTrackRequest = new model.CreateTrackRequest();
            let skipVerification = false;
            if (!s.text) {
                createTrackRequest = await this.props.connect.lo_ctx.val().Track.createTrackRequest(this.state.url as string)
                track.Track.Event(track.TrackCategory.webaction, track.TrackEvent.createTrackRequestFromUrl);
            }
            else {
                createTrackRequest.text = s.text;
                let t = new model.Track();
                createTrackRequest.track = t;
                createTrackRequest.track.title = s.text.split(' ').slice(0,6).join(' ')+' ...'
                track.Track.Event(track.TrackCategory.webaction, track.TrackEvent.createTrackRequestFromText);
                let settings = await this.props.connect.lo_ctx.val().CustomerSettings.getSetting();
                
                if (!settings.has_purchased_track && s.text.length < 10000) {
                    skipVerification = true;
                }
            }

            let requestId = this.props.connect.lo_ctx.val().generateNewId();
            createTrackRequest.track.podcast_id = this.getPodcastId();
            sessionStorage.setItem('requestId:' + requestId, JSON.stringify(createTrackRequest));
            if (skipVerification) {
                createTrackRequest.track.title = s.text.split(' ').slice(0,6).join(' ')+' ...'
                this.props.connect.lo_ctx.val().Track.processTrackRequest(createTrackRequest);
                track.Track.Event(track.TrackCategory.webaction, track.TrackEvent.quickPurchaseTrack);
                types.ViewState.navigate(types.ViewState.hashPodCastView(createTrackRequest.track.podcast_id))
            }
            else {
                types.ViewState.navigate(types.ViewState.hashTrackValidate(requestId))
            }

        }
        catch (e) {
            track.Track.reportError(e, 'Unable to grab HTML', true, this.props.connect.dispatch);


        }
    }
    handleChange(value: any, field: string) {
        let s = { ...this.state };
        s.createTrackRequest.track[field] = value;
        this.setState(s);
    }
    convertClick(e: any) {
        let s = { ...this.state };
        this.props.connect.lo_ctx.val().Track.processTrackRequest(s.createTrackRequest);
        types.ViewState.navigate(types.ViewState.hashPodCastView(s.createTrackRequest.track.podcast_id))
    }
    wordCount(str: string) {
        return str.split(' ').length
    }
    getPodcastId(): any {
        let queryValues = queryString.parse(this.props['location'].search)
        let val = this.state.podcastId ? this.state.podcastId : queryValues.podcast_id;
        return val ? val : this.props.connect.lo_PodCasts.val()[0].id
    }
    change(field: string, value: any) {
        let s = { ...this.state };
        s[field] = value;
        s.fieldCheck[field] = true;
        let errors: Array<types.ValidationError> = s.errors ? new Array<types.ValidationError>() : s.errors;
        errors = errors.filter(x => x.field != field);
        let vr = helper.validateField(s, field, value)
        if (vr) {
            errors = errors.concat(vr.errors)
        }
        s.errors = errors;
        this.setState(s);

    }
    render() {
        const { classes } = this.props;
        let me = this;
        let track = this.state.createTrackRequest.track;
        //this.props.match.params
        if (!this.props.connect.lo_PodCasts.completed()) {
            return (<div></div>)
        }
        /* let queryValues = queryString.parse(this.props['location'].search)
         
         let defaultPodCast = this.props.connect.lo_PodCasts.val().find(x => x.id == queryValues.podcast_id);
         if (!defaultPodCast) {
             defaultPodCast = this.props.connect.lo_PodCasts.val()[0]
         }*/
        let podcastId: any = this.getPodcastId();//this.state.podcastId ? this.state.podcastId : defaultPodCast.id;
        let creditsNeeded = 0;
        if (this.state.step == CreateTrackStep.verify) {
            //creditsNeeded = this.props.connect.lo_ctx.val().Transaction.getCreditsNeededForTrackRequest(this.state.createTrackRequest);

        }

        let errors = helper.validateForm(this.state).errors;
        let hasErrors = errors.length > 0;
        console.log('has errors ' + hasErrors)


        return (

            <Card>
                <CardHeader color="rose" icon>
                    <CardIcon color="rose">
                        <Mic />
                    </CardIcon>
                    <h4 className={classes.cardIconTitle}>New Track</h4>
                </CardHeader>
                <CardBody>

                    <GridContainer>
                        <GridItem xs={12} sm={12} md={9}>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={12}>
                                    <CustomInput

                                        labelText="Enter URL of the article or website you want to listen to."
                                        id="url"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        helpText={helper.getFirstError('url', this.state.errors)}
                                        success={this.state.fieldCheck['url'] && !helper.getFirstError('url', this.state.errors)}
                                        error={helper.getFirstError('url', this.state.errors)}

                                        disable={this.state.step == CreateTrackStep.processingUrl}
                                        value={this.state.url}
                                        inputProps={{
                                            disable: this.state.step == CreateTrackStep.processingUrl,
                                            onChange: (e) => {
                                                me.change('url', e.target.value)

                                            },
                                            onKeyDown: (e) => {


                                                if (e.which === 13) {
                                                    {
                                                        e.stopPropagation();
                                                        if (!hasErrors)
                                                            me.processUrl(e)
                                                        return false;
                                                    }

                                                }
                                            }
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    or
                                    <FormControl
                                        fullWidth
                                    >
                                        <CustomInput
                                            id="filled-multiline-static"

                                            labelText="Enter or paste text you want to listen to."
                                            helpText={helper.getFirstError('text', this.state.errors)}
                                            success={this.state.fieldCheck['text'] && !helper.getFirstError('text', this.state.errors)}
                                            error={helper.getFirstError('text', this.state.errors)}


                                            inputProps={{
                                                multiline: true,
                                                fullWidth: true,
                                                value: this.state.createTrackRequest.text,
                                                onKeyDown: (e) => {


                                                    if (e.which === 13) {
                                                        {
                                                            e.stopPropagation();
                                                            if (!hasErrors)
                                                                me.processUrl(e)
                                                            return false;
                                                        }

                                                    }
                                                },
                                                onChange: (e) => {

                                                    me.change('text', e.target.value)

                                                }
                                            }}
                                            className={classes.textField}
                                            margin="normal"

                                        />
                                    </FormControl>

                                </GridItem>
                            </GridContainer>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={3}>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={12}>

                                    <Select
                                        fullWidth
                                        value={podcastId}
                                        disabled={this.state.step == CreateTrackStep.processingUrl}
                                        onChange={(e: any) => {
                                            let s = { ...me.state }
                                            s.podcastId = e.target.value

                                            me.setState(s);

                                        }}
                                        MenuProps={{ className: classes.selectMenu }}
                                        style={{ paddingTop: '10px' }}
                                        classes={{ select: classes.select }}
                                        inputProps={{
                                            name: "multipleSelect",
                                            id: "multiple-select",

                                        }}
                                        renderValue={(e: Array<any>) => {
                                            let podcast = me.props.connect.lo_PodCasts.val().find(x => x.id == podcastId)
                                            if (podcast) {
                                                return (
                                                    <span><img src={podcast.image_url} width='30' height='30' /> {podcast.title}</span>
                                                )
                                            }
                                            else {
                                                return (
                                                    <span>Select PodCast </span>
                                                )
                                            }
                                        }}
                                    >

                                        {me.props.connect.lo_PodCasts.val().filter(x=>x.podcast_type == model.PodCastType.adhoc).map((podcast: model.PodCast) => (
                                            <MenuItem
                                                key={podcast.id}

                                                classes={{
                                                    root: classes.selectMenuItem,
                                                    selected: classes.selectMenuItemSelectedMultiple
                                                }}
                                                value={podcast.id.toString()}
                                            >
                                                <span><img width='30' height='30' src={podcast.image_url} /> {podcast.title}</span>



                                            </MenuItem>
                                        ))}



                                    </Select>

                                </GridItem>
                                <GridItem xs={12} >
                                    <div style={{
                                        'display': 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '50px'
                                    }}>
                                        <Button
                                            color="rose"
                                            onClick={this.processUrl.bind(this)}
                                            variant="contained"

                                            disabled={this.state.step == CreateTrackStep.processingUrl || hasErrors}

                                            className={classes.registerButton}
                                        >
                                            {this.state.step == CreateTrackStep.processingUrl && (
                                                <span>Grabbing Contents...</span>
                                            )
                                            }

                                            {this.state.step == CreateTrackStep.url && (
                                                <span>Continue</span>
                                            )}
                                        </Button>
                                    </div>
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>




                </CardBody>

            </Card>

        );
    }
}

export function mapStateToProps(state: types.IState) {
    return {
        connect: state
    };
}
export default connect(
    mapStateToProps,
    null
)(withStyles(styles as any)(CreateTrackView));




// WEBPACK FOOTER //
// ./src/views/tracks/CreateTrackView.tsx